export default __webpack_public_path__ + "static/social-mountain-time-81ea073c7ef4c563dd420d3c3d9bad5e.jpg";